<template>
  <div class="market-switcher">
    <div class="market-switcher__header">
      <h2
        class="text-heading-xl text-heading-3xl-desktop"
        v-text="$string('general.market_switcher.heading')"
      />
      <p
        class="text-body-m"
        v-text="$string('general.market_switcher.subheading')"
      />
    </div>

    <form
      method="post"
      action="/localization"
      class="market-switcher__form"
      @submit.prevent="onSubmit"
    >
      <input
        type="hidden"
        name="_method"
        value="put"
      >

      <input
        type="hidden"
        name="return_to"
        :value="currentURL"
      >

      <div class="market-switcher__selectors">
        <select
          class="market-switcher__select text-body-s"
          name="country_code"
          @change="handleCountrySelect"
        >
          <option
            v-for="(country) of localization.countries"
            :key="country.code"
            :value="country.code"
            :selected="selectedCountry.name === country.name"
            v-text="country.name"
          />
        </select>

        <select
          ref="langSelect"
          class="market-switcher__select text-body-s"
          name="language_code"
        >
          <option
            v-for="(language) of localization.languages"
            :key="language.code"
            :value="language.code"
            :selected="selectedLanguage.name === language.name"
            v-text="language.name"
          />
        </select>

        <btn
          class="market-switcher__button"
          :label="$string('general.market_switcher.submit')"
          modifiers="small primary"
          :show-icon="false"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>

/**
 * Vue: Market Switcher (market-switcher)
 * -----------------------------------------------------------------------------
 * Snippet containing Market Switcher
 *
 */
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'

export default {
  name: 'MarketSwitcher',

  components: {
    Btn,
  },

  data() {
    return {
      currentURL: '',
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      localization: (state) => state['market-switcher'].localization,
      selectedCountry: (state) => state['market-switcher'].country,
      selectedLanguage: (state) => state['market-switcher'].language,
    }),
  },

  mounted() {
    this.currentURL = `${window.location.pathname}?${new URLSearchParams(window.location.search)}${window.location.hash}`
  },

  methods: {

    /**
     * Update language on country select change, only if GB or DE.
     * @param {Event} event - Change event.
     */
    handleCountrySelect(event) {
      switch (event.target.value) {
        case 'GB':
          this.$refs.langSelect.value = 'en'
          break
        case 'DE':
          this.$refs.langSelect.value = 'de'
          break
      }
    },
    onSubmit(event) {
      const form = event.target
      const formData = new FormData(form)

      const country = formData.get('country_code')
      const language = formData.get('language_code')

      localStorage.setItem('preferred_country', country)
      localStorage.setItem('preferred_language', language)
      form.submit()
    },
  },
}
</script>

<style lang="scss">
@import './market-switcher';
</style>
